import { gql } from "@apollo/client";

export const GET_USER_CLIPS = gql`
  query GetUserClips(
    $first: Int
    $after: String
    $filters: ClipFilter!
    $userId: String
  ) {
    getUser(_id: $userId) {
      _id
      id
      avatar
      userGroup {
        type
        active
      }
      rank
      username
      discord {
        avatar
        id
        username
      }
      clips(first: $first, after: $after, filters: $filters) {
        nodes {
          title
          id
          shareId
          internalId
          game
          canRequestPortrait
          hasPortrait
          views
          createdAt
          isRemixable
          isPinned
          thumbnailUrl(style: STANDARD)
          url(orientation: LANDSCAPE)
          portraitUrl: url(orientation: PORTRAIT)
          username
          type
          moment {
            id
          }
          reactions {
            count
            type
          }
          remixOf {
            id
            shareId
            user {
              id
              username
              avatarUrl
              _id
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
          totalCount
        }
      }
    }
  }
`;
